var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#Gradiente_sem_nome_181);\n      }\n\n      .st1 {\n        fill: url(#Gradiente_sem_nome_18);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_18",
    "data-name": "Gradiente sem nome 18",
    x1: 4.26,
    y1: 57.4,
    x2: 76,
    y2: 50.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0072fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_181",
    "data-name": "Gradiente sem nome 18",
    x1: 1.75,
    y1: 29.61,
    x2: 73.5,
    y2: 23.13,
    xlinkHref: "#Gradiente_sem_nome_18"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.28,26.41c-13.18,2.89-52.6,12.91-59.61,14.69l-8.6-9.22c-.38-.41-.93-.63-1.49-.58l-5.33.32c-.54.05-1.05.32-1.38.77-.33.45-.44,1.02-.31,1.56l3.74,14.97c.72,2.88,2.77,5.16,5.47,6.12,2.39.85,6.38,1.7,11.74.93,6.92-.98,17.44-2.77,22.69-3.67l-9.45,25.27c-.25.64-.1,1.37.33,1.89.28.32.66.52,1.07.6.26.05.51.04.76-.01l4.22-.97c2.51-.58,4.7-2.06,6.18-4.16l19.66-27.95c3.57-.86,19.28-4.8,26.19-8.98,1.16-.7,1.99-1.88,2.25-3.22.27-1.36-.02-2.76-.82-3.88-1.92-2.66-6.71-6.79-17.31-4.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.04,20.46l-3.53,1.15c-.63.19-1.08.71-1.24,1.35-.16.64.04,1.3.53,1.77l9.37,9.09c7.19-1.8,13.32-3.34,18.55-4.63l-14.89-7.95c-2.68-1.43-5.88-1.72-8.78-.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.8aa212590b7fe011d7d76690f9eae0d5.svg";
export { ForwardRef as ReactComponent };